// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__3mxzw","box":"styles_box__2fNms"};